import React, { useRef } from "react";
import { FaRegImage } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { Resizable } from "re-resizable";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { htmlToDraftJs } from "../../../editor/utils/htmlToDraftJs";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { isUrlValid } from "../../../editor/utils/urlValidation";
import AssetsModal from "../../../core/AssetsModal";

const FooterSettings = ({ footerData, setFooterData, isEdited, setIsEdited }) => {
  const urlRef = useRef(null);

  const handleOnImageUrlChange = () => {
    const value = urlRef.current.value;
    setFooterData((prev) => ({
      ...prev,
      image: {
        ...prev.image,
        url: { value, isValid: isUrlValid(value) },
      },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnFileChange = (data) => {
    const src = data.files[0].file;
    setFooterData((prev) => ({
      ...prev,
      image: { ...prev.image, imgSrc: src },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnResize = (e, direction, ref) => {
    const height = ref.clientHeight;
    setFooterData((prev) => ({
      ...prev,
      image: { ...prev.image, styles: { ...prev.image.styles, height } },
    }));
    !isEdited && setIsEdited(true);
  };

  const handleOnTextChange = (editorState) => {
    const currentContent = editorState.getCurrentContent();
    const markup = draftToHtml(convertToRaw(currentContent));
    const hasText = currentContent.hasText();
    setFooterData((prev) => ({
      ...prev,
      text: { ...prev.text, markup, hasText },
    }));
    !isEdited && setIsEdited(true);
  };

  return (
    <>
      <Form.Group className="image">
        <h4>Footer Image</h4>
        <Form.Group>
          <Form.Label>Link Image: </Form.Label>
          <Form.Control
            type="url"
            placeholder="URL"
            ref={urlRef}
            onChange={handleOnImageUrlChange}
            defaultValue={footerData.image.url?.value || ""}
            style={{
              borderBottomColor: footerData.image.url?.isValid ? "green" : "red",
            }}
          />
        </Form.Group>
        <Form.Group
          className="image-preview"
          style={{ display: footerData.image.imgSrc ? "flex" : "inherit" }}
        >
          {footerData.image.imgSrc ? (
            <Resizable
              className="image header-footer-resize"
              minHeight={10}
              maxHeight={260}
              enable={{ top: true, bottom: true }}
              size={{
                height: footerData.image.styles?.height || 100,
              }}
              onResize={handleOnResize}
              onMouseDown={(e) => {
                if (e.target.style.cursor && e.target.style.cursor.includes("resize")) {
                  e.preventDefault();
                }
              }}
            >
              <AssetsModal callBackFile={handleOnFileChange} callLocation="Footer-image-one">
                <img
                  src={footerData.image.imgSrc}
                  alt="footer"
                  style={{
                    height: footerData.image.styles?.height || 100,
                    objectFit: "contain",
                  }}
                />
              </AssetsModal>
            </Resizable>
          ) : (
            <AssetsModal callBackFile={handleOnFileChange} callLocation="Footer-image-one">
              <div className="icon-wrapper">
                <FaRegImage size="70px" />
              </div>
            </AssetsModal>
          )}
        </Form.Group>
        <hr />
      </Form.Group>

      <div className="textSettings">
        <h4>Footer Text</h4>
        <Editor
          defaultEditorState={htmlToDraftJs(footerData.text.markup)}
          wrapperClassName="wrapper"
          editorClassName="editor"
          onEditorStateChange={handleOnTextChange}
        />
      </div>
      <hr />
    </>
  );
};

export default FooterSettings;
